import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-banner-link',
  templateUrl: 'banner-link.component.html'
})
export class BannerLinkComponent {
  @Input() item: any;
}
